export const courseTypeList = [{
    id: 0,
    name: "免费"
  },
  {
    id: 1,
    name: "基础班"
  },
  {
    id: 2,
    name: "标准班"
  }
]

// 题型
export const subjectType = [{
    id: 1,
    name: "单选"
  },
  {
    id: 2,
    name: "多选"
  },
  {
    id: 3,
    name: "判断"
  },
  {
    id: 4,
    name: "材料"
  },
  {
    id: 5,
    name: "写作"
  },
  // {
  //   id: 6,
  //   name: "简答"
  // },
  // {
  //   id: 7,
  //   name: "论述"
  // }, {
  //   id: 8,
  //   name: "活动设计"
  // }, {
  //   id: 9,
  //   name: "教学设计"
  // }, 
  {
    id: 10,
    name: "辨析"
  },
  //  {
  //   id: 11,
  //   name: "不定项选择"
  // }, {
  //   id: 16,
  //   name: "计算分析题"
  // }, {
  //   id: 17,
  //   name: "综合题"
  // }
]

export const optionData = ['A','B','C','D','E','F','G']

export const publishStatus = [
  {
    id:1,
    name:"未发布"
  },
  {
    id:2,
    name:"已发布"
  }
]